import React, { useCallback } from 'react';
import type { ReactNode } from 'react';
import { element } from 'prop-types';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { GenericErrorBoundary } from '@confluence/error-boundary/entry-points/GenericErrorBoundary.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { EngagementProviderComponent } from './EngagementProviderComponent.tsx';

function EngagementProviderComponentWrapper({ children }: { children: ReactNode }): ReactNode {
	const { isLicensed } = useSessionData();
	const renderOnError = useCallback(() => {
		return children;
	}, [children]);

	if (!isLicensed) {
		return children;
	}

	return (
		<GenericErrorBoundary attribution={Attribution.INHERIT} renderOnError={renderOnError}>
			<EngagementProviderComponent>{children}</EngagementProviderComponent>
		</GenericErrorBoundary>
	);
}
declare namespace EngagementProviderComponentWrapper {
	export let propTypes: {
		children: typeof element;
	};
}

EngagementProviderComponentWrapper.propTypes = {
	children: element,
};

export const EngagementProvider: typeof EngagementProviderComponentWrapper =
	EngagementProviderComponentWrapper;
